module.exports = window["popupMaker"]["utils"];